export function isFirstPageOfPillow(pages, section) {
  let result = false;
  if (section) {
    const pageID = section.getIn(['spreads', 0, 'pages', 0, 'pageID']);
    if (pageID && pages && pages.first().get('id') === pageID) {
      result = true;
    }
  }

  return result;
}
